import clsx from 'clsx';
import React from 'react';

interface RadioButtonsProps {
  otherClasses?: string;
  options: { label: string; value: string }[];
  value: string;
  onChange: (value: string) => void;
  errorMessage?: string;
  onBlur?: (e: any) => void;
}

const RadioButtons: React.FC<RadioButtonsProps> = ({
  otherClasses,
  options,
  value,
  onChange,
  onBlur,
  errorMessage = '',
}) => {
  const radioButtonsClasses = clsx(
    otherClasses,
    'flex flex-col gap-5 relative',
  );

  return (
    <div className={radioButtonsClasses} data-testid="radio-buttons">
      {options.map((option) => (
        <button
          onBlur={onBlur}
          type="button"
          key={option.value}
          onClick={() => onChange(option.value)}
          className={clsx(
            'font-inter-variable hover:text-brand-byzantine global-transition flex w-fit items-center gap-2.5 text-left text-sm leading-4 lg:gap-15 lg:text-base lg:leading-5',
            value === option.value
              ? 'text-brand-byzantine font-bold'
              : 'text-neutral-tones-text font-normal',
          )}
        >
          <span className="border-brand-byzantine flex h-5 min-h-5 min-w-5 items-center justify-center rounded-full border-2 lg:h-6 lg:min-h-6 lg:w-6 lg:min-w-6">
            <span
              className={clsx(
                'global-transition h-2.5 w-2.5 rounded-full lg:h-3 lg:w-3',
                value === option.value
                  ? 'bg-brand-byzantine'
                  : 'bg-transparent',
              )}
            ></span>
          </span>
          {option.label}
        </button>
      ))}
      {errorMessage !== '' && (
        <span
          role="alert"
          className="font-inter-variable text-brand-posh-pink absolute -bottom-5 left-0 text-xs font-normal"
        >
          {errorMessage}
        </span>
      )}
    </div>
  );
};

export default RadioButtons;
